import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppFailureRouteParams } from '../../core/routeparams';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-failure',
  templateUrl: './app-failure.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppFailureComponent implements OnInit {
  private message: string;
  private backLink: string;

  constructor(
    private route: ActivatedRoute,
    private translateService: TranslateService,
  ) {}

  public get userMessage(): string {
    if (!!this.message && this.message !== 'default') {
      return this.message;
    }
    return this.translateService.instant('APP_FAILURE.SITE_ERROR');
  }

  public get userBackLink(): string {
    if (this.hasBackLink()) {
      return this.backLink;
    }
    return '';
  }

  ngOnInit(): void {
    this.message = (this.route.snapshot.params as AppFailureRouteParams).message;
    this.backLink = (this.route.snapshot.params as AppFailureRouteParams).backLink;
  }

  public hasBackLink(): boolean {
    return !!this.backLink;
  }
}
